'use client';

import { useState } from 'react';

import { QuestionAnswerItem } from '@/components/QuestionAnswerItem';
import type { FaqItem } from '@/modules/seo/content/shared';
import { ScFaqContainer } from './styled';

interface SeoFaqListProps {
  items: FaqItem[];
}

export const ClientSeoFaq = ({ items }: SeoFaqListProps) => {
  const [openAnswer, setOpenAnswer] = useState(-1);

  const handleSelectQuestion = (index: number) => () => {
    setOpenAnswer((prev) => (index === prev ? -1 : index));
  };

  return (
    <ScFaqContainer $isOpen={openAnswer !== -1}>
      {items.map(({ question, answer }, index) => (
        <QuestionAnswerItem
          description={answer}
          handleOpen={handleSelectQuestion(index)}
          isOpen={index === openAnswer}
          key={question}
          title={question}
        />
      ))}
    </ScFaqContainer>
  );
};
